function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScShoppingCart = function SvgScShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M0 2.5H3.27005C3.70492 2.5 4.08993 2.78104 4.22247 3.19522L5.44001 7M5.44001 7H19.2928C20.083 7 20.561 7.87344 20.135 8.53905L16 15H8.00003L5.44001 7Z",
    stroke: "var(--on-surface)",
    style: {
      stroke: "var(--on-surface)",
      strokeOpacity: 1
    },
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M10 20C10 21.1046 9.1046 22 8.00003 22C6.89546 22 6.00003 21.1046 6.00003 20C6.00003 18.8954 6.89546 18 8.00003 18C9.1046 18 10 18.8954 10 20Z",
    fill: "var(--on-surface)",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M18 20C18 21.1046 17.1046 22 16 22C14.8955 22 14 21.1046 14 20C14 18.8954 14.8955 18 16 18C17.1046 18 18 18.8954 18 20Z",
    fill: "var(--on-surface)",
    style: {
      fill: "var(--on-surface)",
      fillOpacity: 1
    }
  }));
};
export default SvgScShoppingCart;